// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
//首页
import home from '@/views/home/home';
// 商品管理
import Goods from '@/views/goods/Goods';
// 商铺管理
import shopManagement from '@/views/shop/management';
// 添加活动
import addActive from '@/views/shop/addActive';
// 添加专场
import special from '@/views/shop/special';
// 添加活动分类
import addActiveCategorize from '@/views/shop/addActiveCategorize';
// 商品分类管理
import addCategorize from '@/views/shop/addCategorize';

// 资讯链接
import information from '@/views/shop/information';
// 上传轮播图
import upLoop from '@/views/shop/upLoop';
// 上传活动轮播图
import upActiveLoop from '@/views/shop/upActiveLoop';
//帮助中心
import helpCenter from '@/views/shop/helpCenter';
//财务账单
import financial from '@/views/shop/financial';
/**
 * 订单管理
 */
// 订单管理
import Order from '@/views/pay/Order';
import orderDetail from '@/views/pay/orderDetail';
// 优惠设置
import preferential from '@/views/system/preferential';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/index',
    name: '首页',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [{
      path: '/home/home',
      name: '首页',
      component: home,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/goods/Goods',
      name: '商品管理',
      component: Goods,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/user',
      name: '用户管理',
      component: user,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/shop/management',
      name: '商铺管理',
      component: shopManagement,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/shop/addActive',
      name: '添加活动',
      component: addActive,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/shop/addActiveCategorize',
      name: '添加活动分类',
      component: addActiveCategorize,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/shop/addCategorize',
      name: '添加分类',
      component: addCategorize,
      meta: {
        requireAuth: true
      }
    },

    {
      path: '/shop/information',
      name: '资讯链接',
      component: information,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/shop/upLoop',
      name: '上传轮播图',
      component: upLoop,
      meta: {
        requireAuth: true
      }
    },

    {
      path: '/shop/upActiveLoop',
      name: '上传活动轮播图',
      component: upActiveLoop,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/shop/helpCenter',
      name: '帮助中心',
      component: helpCenter,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/shop/special',
      name: '专场管理',
      component: special,
      meta: {
        requireAuth: true
      }
    },
    
    {
      path: '/shop/financial',
      name: '财务账单',
      component: financial,
      meta: {
        requireAuth: true
      }
    },

    {
      path: '/pay/Order',
      name: '交易订单',
      component: Order,
      meta: {
        requireAuth: true
      }
    }, 
    {
      path: '/orderDetail',
      name: '交易订单',
      component: orderDetail,
      meta: {
        requireAuth: true
      }
    }, 
    {
      path: '/system/preferential',
      name: '优惠设置',
      component: preferential,
      meta: {
        requireAuth: true
      }
    },]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js